// const Welcome = () => import('~/pages/welcome').then(m => m.default || m)
const Login = () =>
    import('~/pages/auth/login').then(m => m.default || m)
const Register = () =>
    import('~/pages/auth/register').then(m => m.default || m)
const PasswordEmail = () =>
    import('~/pages/auth/password/email').then(m => m.default || m)
const PasswordReset = () =>
    import('~/pages/auth/password/reset').then(m => m.default || m)
const NotFound = () =>
    import('~/pages/errors/404').then(m => m.default || m)

const Home = () =>
    import('~/pages/home').then(m => m.default || m)
const Settings = () =>
    import('~/pages/settings/index').then(m => m.default || m)
const SettingsProfile = () =>
    import('~/pages/settings/profile').then(m => m.default || m)
const SettingsPassword = () =>
    import('~/pages/settings/password').then(m => m.default || m)
const SettingsUsers = () =>
    import('~/pages/settings/users').then(m => m.default || m)
const SettingsEmpresas = () =>
    import('~/pages/settings/empresas').then(m => m.default || m)
const SettingsServicos = () =>
    import('~/pages/settings/servicos').then(m => m.default || m)
const SettingsJornada = () =>
    import('~/pages/settings/cad_edit_jornada').then(m => m.default || m)
const Jornadas = () =>
    import('~/pages/settings/jornadas').then(m => m.default || m)
const SettingsExcecoes = () =>
    import('~/pages/settings/excecoes').then(m => m.default || m)
const SettingsProfissionais = () =>
    import('~/pages/settings/profissionais').then(m => m.default || m)
const SettingsClientes = () =>
    import('~/pages/settings/clientes').then(m => m.default || m)
const SettingsProdutos = () =>
    import('~/pages/settings/produtos').then(m => m.default || m)
const SettingsCatProdutos = () =>
    import('~/pages/settings/categorias').then(m => m.default || m)
const SettingsAvaliacoes = () =>
    import('~/pages/settings/avaliacoes').then(m => m.default || m)
const SettingsEmpresa = () =>
    import('~/pages/settings/empresa').then(m => m.default || m)

const CadUser = () =>
    import('~/pages/settings/cad_user').then(m => m.default || m)
const CadEmpresa = () =>
    import('~/pages/settings/cad_empresa').then(m => m.default || m)
const CadServico = () =>
    import('~/pages/settings/cad_servico').then(m => m.default || m)
const CadExcecoes = () =>
    import('~/pages/settings/cad_excecao').then(m => m.default || m)
const CadProfissionais = () =>
    import('~/pages/settings/cad_profissional').then(m => m.default || m)
const CadClientes = () =>
    import('~/pages/settings/cad_cliente').then(m => m.default || m)
const CadProduto = () =>
    import('~/pages/settings/cad_produto').then(m => m.default || m)
const CadCatProduto = () =>
    import('~/pages/settings/cad_cat_produto').then(m => m.default || m)
const CadPedido = () =>
    import('~/pages/pedidos/cad_pedido').then(m => m.default || m)
const Historico = () =>
    import('~/pages/pedidos/historico').then(m => m.default || m)

const Agenda = () =>
    import('~/pages/agendamentos/agenda').then(m => m.default || m)
const Agendar = () =>
    import('~/pages/agendamentos/agendar').then(m => m.default || m)
const AgendamentosPendentes = () =>
    import('~/pages/agendamentos/pendentes').then(m => m.default || m)
const AgendamentosRecentes = () =>
    import('~/pages/agendamentos/recentes').then(m => m.default || m)
const Sumidos = () =>
    import('~/pages/agendamentos/sumidos').then(m => m.default || m)

const Pedidos = () =>
    import('~/pages/pedidos/pedidos').then(m => m.default || m)
const Pedido = () =>
    import('~/pages/pedidos/pedido').then(m => m.default || m)

const Politica = () =>
    import('~/pages/policy').then(m => m.default || m)

export default [
  { path: '/', name: 'welcome', component: Home },

  { path: '/login', name: 'login', component: Login },
  { path: '/register', name: 'register', component: Register },
  { path: '/password/reset', name: 'password.request', component: PasswordEmail },
  { path: '/password/reset/:token', name: 'password.reset', component: PasswordReset },
  { path: '/politica', name: 'politica', component: Politica },

  { path: '/cad_pedido', name: 'pedido.cad_pedido', component: CadPedido },
  { path: '/historico', name: 'pedido.historico', component: Historico },

  { path: '/agenda', name: 'agenda', component: Agenda },
  { path: '/agendar', name: 'agendar', component: Agendar },
  { path: '/agendamentos', name: 'agendamentos', component: Home },
  { path: '/agendamentos/pendentes', name: 'agendamentos.pendentes', component: AgendamentosPendentes },
  { path: '/agendamentos/recentes', name: 'agendamentos.recentes', component: AgendamentosRecentes },
  { path: '/agendamentos/sumidos', name: 'agendamentos.sumidos', component: Sumidos },
  { path: '/agendamentos/:id', name: 'agendamentos.editar', component: Agendar },
  { path: '/pedidos', name: 'pedidos', component: Pedidos },
  { path: '/pedidos/:id', name: 'pedido', component: Pedido },

  { path: '/home', name: 'home', component: Home },
  {
    path: '/config',
    component: Settings,
    children: [
      { path: '', redirect: { name: 'config.profile' } },
      { path: 'profile', name: 'config.profile', component: SettingsProfile },
      { path: 'password', name: 'config.password', component: SettingsPassword },
      { path: 'users/password/:id', name: 'config.user.password', component: SettingsPassword },
      { path: 'users', name: 'config.users', component: SettingsUsers },
      { path: 'users/novo', name: 'config.users.new', component: CadUser },
      { path: 'users/editar/:id', name: 'config.users.edit', component: CadUser },
      { path: 'empresas', name: 'config.empresas', component: SettingsEmpresas },
      { path: 'empresas/editar/:id', name: 'config.empresas.editar', component: CadEmpresa },
      { path: 'empresas/novo', name: 'config.empresas.new', component: CadEmpresa },
      { path: 'servicos', name: 'config.servicos', component: SettingsServicos },
      { path: 'servicos/novo', name: 'config.servicos.new', component: CadServico },
      { path: 'servicos/editar/:id', name: 'config.servicos.editar', component: CadServico },
      { path: 'jornada', name: 'config.jornada', component: SettingsJornada },
      { path: 'jornadas', name: 'config.jornadas', component: Jornadas },
      { path: 'excecoes', name: 'config.excecoes', component: SettingsExcecoes },
      { path: 'excecoes/novo', name: 'config.excecoes.new', component: CadExcecoes },
      { path: 'excecoes/editar/:id', name: 'config.excecoes.editar', component: CadExcecoes },
      { path: 'profissionais', name: 'config.profissionais', component: SettingsProfissionais },
      { path: 'profissionais/novo', name: 'config.profissionais.new', component: CadProfissionais },
      { path: 'profissionais/editar/:id', name: 'config.profissionais.editar', component: CadProfissionais },
      { path: 'clientes', name: 'config.clientes', component: SettingsClientes },
      { path: 'clientes/novo', name: 'config.clientes.new', component: CadClientes },
      { path: 'clientes/editar/:id', name: 'config.clientes.editar', component: CadClientes },
      { path: 'produtos', name: 'config.produtos', component: SettingsProdutos },
      { path: 'produtos/novo', name: 'config.produtos.new', component: CadProduto },
      { path: 'produtos/editar/:id', name: 'config.produtos.editar', component: CadProduto },
      { path: 'cat_produtos', name: 'config.categorias_produto', component: SettingsCatProdutos },
      { path: 'cat_produtos/novo', name: 'config.categorias_produto.new', component: CadCatProduto },
      { path: 'cat_produtos/editar/:id', name: 'config.categorias_produto.editar', component: CadCatProduto },
      { path: 'avaliacoes', name: 'config.avaliacoes', component: SettingsAvaliacoes },
      { path: 'empresa', name: 'config.empresa', component: SettingsEmpresa }
    ]
  },

  { path: '*', component: NotFound }
]



// WEBPACK FOOTER //
// ./resources/js/router/routes.js